export default "__VITE_ASSET__DzldZj8___"